import { render, staticRenderFns } from "./channelAreaDaymax.vue?vue&type=template&id=5190fec6"
import script from "./channelAreaDaymax.vue?vue&type=script&lang=js"
export * from "./channelAreaDaymax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5190fec6')) {
      api.createRecord('5190fec6', component.options)
    } else {
      api.reload('5190fec6', component.options)
    }
    module.hot.accept("./channelAreaDaymax.vue?vue&type=template&id=5190fec6", function () {
      api.rerender('5190fec6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ad/channelAreaDaymax.vue"
export default component.exports